import type { FC } from "react";

import { Button } from "@similarweb/ui-components";

import type { IBaseBannerTheme } from "../StyledTrialBanner";

import { ButtonText, StyledIconButton } from "./StyledCTAButton";

interface ICTAButtonProps {
    text: string;
    onClick: () => void;
    theme: IBaseBannerTheme;
    isShopperICPBanner: boolean;
}

const CTAButton: FC<ICTAButtonProps> = ({ onClick, text, theme, isShopperICPBanner }) => {
    // @ts-expect-error - Theme type mismatch: IBaseBannerTheme vs boolean (pre-existing issue)
    const buttonContent = <ButtonText theme={theme}>{text}</ButtonText>;

    return isShopperICPBanner ? (
        <Button
            type="inverted"
            onClick={onClick}
        >
            {buttonContent}
        </Button>
    ) : (
        <StyledIconButton
            // @ts-expect-error - Theme type mismatch: IBaseBannerTheme vs IBannerTheme (pre-existing issue)
            theme={theme}
            type="inverted"
            iconName="sparkles"
            onClick={onClick}
        >
            {buttonContent}
        </StyledIconButton>
    );
};

export default CTAButton;
